<template>
    <AppLayout>
        <BreadCrumbs :bread-crumbs="breadCrumbs" />

        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            Home
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3 "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                        >Wholesalers</a>
                    </li>
                </ol>
            </nav>
            <!-- breadcrumb end -->

            <div>
                <!-- Top part to keep search filters add button and stuff -->
                <div class="px-10 mx-auto ">
                    <h1 class="text-3xl font-bold ">
                        Wholesalers
                    </h1>
                    <div class="flex items-center justify-around">
                        <div
                            class="text-lg font-bold text-blue-400 cursor-pointer hover:text-blue-600"
                            :class="filterByAlpha === null ? 'text-blue-800' : ''"
                            @click="goto('wholesalers.index')"
                        >
                            All
                        </div>
                        <div
                            v-for="pos in 26"
                            :key="'alphabet-' + pos"
                            class="text-lg font-bold text-blue-400 cursor-pointer hover:text-blue-600"
                            :class="filterByAlpha === String.fromCharCode(pos + 64) ? 'text-blue-800' : ''"
                            @click="goto('wholesalers.index', {filterByAlpha:String.fromCharCode(pos + 64)})"
                        >
                            {{ String.fromCharCode(pos + 64) }}
                        </div>
                    </div>
                </div>

                <!-- Card content to list the Wholesalers -->
                <div class="flex flex-col p-4 mt-6">
                    <div
                        v-if="wholesalers.length"
                        class="grid grid-cols-1 gap-6 sm:grid-cols-3 xl:grid-cols-4"
                    >
                        <div
                            v-for="wholesaler in wholesalers"
                            :key="'wholesaler-' + wholesaler.id"
                            class="relative h-full max-w-full mx-auto transition-all duration-200 ease-in-out transform bg-white border border-gray-300 rounded-sm shadow-sm cursor-pointer group hover:-translate-y-1 hover:border-gray-400 w-72"
                        >
                            <!-- Individual Wholesaler Card -->
                            <div
                                class="max-w-xs mx-auto overflow-hidden bg-white rounded-lg shadow-lg"
                                @click="goto('products.index', { wholesalerIds: [wholesaler.id] })"
                            >
                                <img
                                    class="object-cover w-full h-48 mt-2"
                                    :src="wholesaler.profile_photo_url"
                                    :alt="wholesaler.name"
                                >

                                <div class="flex items-center justify-between px-4 py-2 bg-gray-900">
                                    <h1 class="text-lg font-bold text-white">
                                        {{ wholesaler.name }}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        No Wholesalers.
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';
import BreadCrumbs from '../../Components/BreadCrumbs.vue';

export default {
    name: 'WholesalersIndex',
    components: {
        AppLayout,
        BreadCrumbs,
    },

    props: {
        wholesalers: {
            type: Array,
            required: true,
        },
        filterByAlpha: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            breadCrumbs: [{ title: 'Wholesalers' }],
        };
    },

    methods: {
        gotoWholesalerPage(wholesaler) {
            this.$inertia.get(route('wholesalers.show', wholesaler.id));
        },
    },
};
</script>
